import { type AxiosRequestConfig } from 'axios'

const updateUserEducation = (id: string, data: any): AxiosRequestConfig => {
  return {
    method: 'PUT',
    url: '/user/info/education/item',
    data,
    params: {
      id
    }
  }
}

export { updateUserEducation }
